export enum RegionName {
  PEE_DEE_COUNTIES = 'Pee Dee',
  LOW_COUNTY_COUNTIES = 'Low County',
  MIDLANDS_COUNTIES = 'Midlands',
  UPSTATE_COUNTIES = 'Upstate',
}
